import { render, staticRenderFns } from "./TopTravelGroupForm.vue?vue&type=template&id=21d9aa68&"
import script from "./TopTravelGroupForm.vue?vue&type=script&lang=js&"
export * from "./TopTravelGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports